var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "headerAddressMain" }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "align-items": "center",
          "flex-grow": "1",
          overflow: "hidden"
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "\n                leftArrowWrapper\n            ",
            on: {
              click: function($event) {
                return _vm.$router.go(-1)
              }
            }
          },
          [
            _c("i", {
              staticClass: "iconfont icon-back leftArrow",
              style: {
                color: _vm.fontColor
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "\n                labelWrapper\n            ",
            style: {
              color: _vm.fontColor
            }
          },
          [
            _vm.label
              ? _c("span", [_vm._v(_vm._s(_vm.label))])
              : _vm._t("default")
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "currentAddressTipWrapper" },
      [
        _c("CurrentAddressTip", {
          attrs: { fontColor: _vm.fontColor, shopId: _vm.shopId }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }